import React from "react";


const SuccessPopup = ({ loginApprove, loginDisapprove }) => {
    return (
        <div className="modal-overlay">
            <div className="modal-content">
                <h3 className="modal-title">Proceed with Signup?</h3>
                <p className="modal-message">
                    Please ensure only one tab of this URL is open to complete your registration as New Customer
                </p>
                <div className="flex justify-end gap-2">
                    <button onClick={loginDisapprove} className="modal-button cancel">
                        Cancel
                    </button>
                    <button onClick={loginApprove} className="modal-button confirm">
                        OK
                    </button> 
                </div>
            </div>
        </div>
    );
};

export default SuccessPopup;
